document.addEventListener('DOMContentLoaded', function () {
  function setupSingleSelectDiscountFilter() {
    // Target all discount percentage filter inputs
    const discountFilters = document.querySelectorAll(
      'input[name="filter.p.m.custom.discount_percentage"]',
    );

    discountFilters.forEach((input) => {
      input.addEventListener('click', function (event) {
        // Prevent default form submission behavior
        event.preventDefault();

        // Get current URL and create URL object for manipulation
        const currentUrl = new URL(window.location.href);
        const searchParams = currentUrl.searchParams;

        // Remove all existing discount percentage parameters
        const urlParams = Array.from(searchParams.entries());
        urlParams.forEach(([key, value]) => {
          if (key === 'filter.p.m.custom.discount_percentage') {
            searchParams.delete(key);
          }
        });

        // If this option is being selected, add it to URL
        if (this.checked) {
          searchParams.append('filter.p.m.custom.discount_percentage', this.value);
        }

        // Navigate to new URL with updated parameters
        window.location.href = currentUrl.toString();
      });
    });
  }

  // Run on page load
  setupSingleSelectDiscountFilter();

  // Handle dynamic updates of filter UI
  document.addEventListener('facetsUpdated', function () {
    setTimeout(setupSingleSelectDiscountFilter, 100);
  });
});
